import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export const useAffiliateCheck = () => {
  const { user, loading } = useAuth();
  const [isAffiliate, setIsAffiliate] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAffiliateStatus = async () => {
      if (!user) {
        setIsAffiliate(false);
        setChecking(false);
        return;
      }

      setChecking(true);
      try {
        // Primary source of truth: an approved affiliate application.
        const { data: appData, error: appError } = await supabase
          .from('affiliate_applications')
          .select('id')
          .eq('user_id', user.id)
          .eq('approval_status', 'approved')
          .maybeSingle();

        if (appError) {
          console.error('Error checking affiliate application:', appError);
        }

        if (appData) {
          setIsAffiliate(true);
          setChecking(false);
          return;
        }

        // Fallback: legacy users marked via profiles.user_type (e.g. AdminMakeAffiliatePanel).
        const { data: profileData, error: profileError } = await supabase
          .from('profiles')
          .select('user_type')
          .eq('id', user.id)
          .maybeSingle();

        if (profileError) {
          console.error('Error checking profile user_type:', profileError);
          setIsAffiliate(false);
        } else {
          setIsAffiliate(profileData?.user_type === 'affiliate');
        }
      } catch (error) {
        console.error('Error in affiliate check:', error);
        setIsAffiliate(false);
      } finally {
        setChecking(false);
      }
    };

    if (!loading) {
      checkAffiliateStatus();
    }
  }, [user, loading]);

  return { isAffiliate, checking };
};
